import React from 'react';
import './styles.css';

const SubtitleText = ({ color, isCentered, as, ...props }) => {
  const colorStyle = color ? ` ${color}` : ' color-1';
  const variantType = 'subtitle-text';
  let className = variantType + colorStyle + (isCentered ? ' centered' : '');
  const Component = as || 'p';

  return <Component className={className}>{props.children}</Component>;
};

export default SubtitleText;
